import { UserNotification } from "@10x/sso";
import { LVStrings } from "@my-dld/assets/strings";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { getUser } from "./User";
import { Redirect } from "react-router";
import React from "react";

export function getNotificationUrl( notification: UserNotification ): string | undefined {
	if ( notification ) {
		switch ( notification.code ) {
			case "PassExpired":
			case "PassExpireSoon":
				return "/mydld/profile/chpwd";
			case "EmailNotVerified":
				return "/mydld/profile/verify_account";
		}
	}
}

export function getResolutionLabel( notification: UserNotification ): LocaleValue {
	if ( notification ) {
		switch ( notification.code ) {
			case "PassExpired":
			case "PassExpireSoon":
				return LVStrings.change_password;
		}
	}
	return LVStrings.resolve;
}

function getNotificationIconClassFromCode( code: string ): string | undefined {
	if ( code ) {
		switch ( code ) {
			case "PassExpired":
			case "PassExpireSoon":
				return "icon-password-change";
		}
	}
	return undefined;
}

export function getNotificationIconClass( notification: UserNotification ): string | undefined {
	if ( notification ) {
		let icon = getNotificationIconClassFromCode( notification.code );
		if ( !icon ) {
			switch ( notification.type ) {
				case "CRITICAL":
					icon = "icon-user-alert-critical";
					break;
				case "WARN":
					icon = "icon-user-alert-warning";
					break;
			}
		}
		return icon;
	}
}

export function getNotificationWrapperClass( notification: UserNotification ): string | undefined {
	if ( notification ) {
		switch ( notification.type ) {
			case "CRITICAL":
				return "alert-danger";
			case "WARN":
				return "alert-warning";
		}
	}
}

export function getCriticalNotifications(): UserNotification[] | undefined {
	const notifications = getUser()?.getUserNotification();
	if ( notifications && notifications.length > 0 ) {
		const criticalNotifications = notifications.filter( x => x.type === "CRITICAL" );
		if ( criticalNotifications.length > 0 ) {
			return criticalNotifications;
		}
	}
	return undefined;
}

export function isValidForOperation() {
	return getCriticalNotifications() == null;
}

export function UserNotificationHandleNavigation( currentLocation: string ) {
	const criticalNotifications = getCriticalNotifications();
	if ( criticalNotifications && criticalNotifications.length > 0 ) {
		const fcn = criticalNotifications.map( x => getNotificationUrl( x ) ).filter( x => x != null );
		if ( fcn.length > 0 ) {
			const to = fcn[ 0 ]!;
			const fc = criticalNotifications.find( x => getNotificationUrl( x ) === to );
			if ( currentLocation !== to )
				return <Redirect to={ { pathname: to, state: { notification: fc } } }/>;
		}
	}
}
